import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { notNullOrWhiteSpace } from '../../shared/validators';
import { DefaultColumnInfo, FormResultInfo } from './admin-edit-column-info';
import { Observable } from 'rxjs';
import { MdlDialogReference, IMdlCustomDialogConfiguration, MdlDialogService } from '@angular-mdl/core';
import { AdminColumnFormComponent, COLUMN_INFO_TOKEN } from './column-form/admin-column-form.component';
import { switchMap, map } from 'rxjs/operators';


@Injectable()
export class AdminEditColumnService {

    constructor(
        public formBuilder: FormBuilder,
        public dialogService: MdlDialogService    ) {

    }

    public openEditDialog(columnInfo: DefaultColumnInfo): Observable<FormResultInfo> {
        return this.openColumnSettingsPopup(columnInfo).pipe(
            switchMap(dialog => dialog.onHide()),
            map((dialogResult: FormResultInfo) => dialogResult || null)
        );
    }

    public openColumnSettingsPopup(columnInfo: DefaultColumnInfo): Observable<MdlDialogReference> {

        const configDialog: IMdlCustomDialogConfiguration = {
            component: AdminColumnFormComponent,
            providers: [{
                provide: COLUMN_INFO_TOKEN, useValue: columnInfo
            }],
            isModal: true,
            classes: 'column-view-dialog',
            clickOutsideToClose: false,
            enterTransitionDuration: 400,
            leaveTransitionDuration: 400
        };

        return this.dialogService.showCustomDialog(configDialog);
    }

}